import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { selectRole } from '../../routing/fetchingfunction/user/user.reducer'

import { TUTOR_ROLE } from '../../constants'

const Marketplace = () => {
  const role = useSelector(selectRole)

  return (
    <div className="max-w-[1280px] w-full mx-auto py-[32px] flex flex-col items-start">
      <div className="w-full flex items-center justify-center flex-col">
        <h1 className="text-4xl text-white font-bold leading-[52px]">
          Want to be part of the Apolo Family?
        </h1>

        <h2 className="text-xl text-white leading-[32px]">
          Look through our creative merchandise to find something that fits your style!
        </h2>

        <div className="w-full flex mt-[32px] gap-[24px]">
          <div className="flex-1 p-[32px] bg-[#FEEBDD] rounded-[10px] flex flex-col items-start">
            <img src="/assets/image/apolo-merch.png" alt="Merch" className="w-full" />

            <h3 className="mt-[20px] text-xl font-bold text-primary-100">Apolo P2P Clothes</h3>

            <h4 className="mt-[8px] text-base text-primary-100">
              Go through “Apolo P2P” inspired T-Shirts, hoodies, hats, socks, and many other
              clothes, available in the best quality.
            </h4>

            <Link
              to="/"
              className="w-[240px] h-[36px] flex items-center justify-center shadow-button text-sm font-semibold text-white rounded-[8px] mt-[20px] bg-primary-button hover:bg-primary-button-hover transition-colors duration-200 ease"
            >
              Buy Apolo Merchandise
            </Link>
          </div>

          <div className="flex-1 p-[32px] bg-[#FEEBDD] rounded-[10px] flex flex-col items-start">
            <img
              src="/assets/image/apolo-hardware.png"
              alt="Books and Hardware"
              className="w-full"
            />

            <h3 className="mt-[20px] text-xl font-bold text-primary-100">
              Apolo P2P Books & Hardware
            </h3>

            <h4 className="mt-[8px] text-base text-primary-100">
              Get important accessories that will be useful during your learning process and your
              work!
            </h4>
          </div>
        </div>

        <p className="text-lg font-normal text-white mt-[32px]">
          Not interested in exploring the market? Click below to explore Apolo P2P and learn more
          about us!
        </p>

        <div className="w-full flex items-center justify-center gap-x-[10px] mt-[20px]">
          {role !== TUTOR_ROLE && (
            <Link
              to="/findtutor"
              className="w-[240px] h-[36px] flex items-center justify-center rounded-[8px] bg-[#1AC057] hover:bg-[#117b38] text-sm font-semibold text-white transition-colors duration-200 ease"
            >
              Find Tutor
            </Link>
          )}

          <Link
            to="/"
            className="w-[240px] h-[36px] flex items-center justify-center rounded-[8px] bg-[#FEEBDD] text-sm font-semibold text-primary-100 hover:text-primary-100"
          >
            Learn more about Apolo P2P
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Marketplace
